module.exports = __webpack_public_path__ + "img/lxwm_card.fe8b4b29.png";